export class CoreService {
  private readonly SentimentsIdName = 'sentiments.sentimentsId';
  private readonly CollapsedModeName = 'sentiments.switchCollapsedMode';
  private sentimentsId: string;
  private collapsedMode: boolean;

  constructor() {
    const id = window.sessionStorage.getItem(this.SentimentsIdName);
    const status = window.sessionStorage.getItem(this.CollapsedModeName);
    if (id) {
      this.sentimentsId = id;
    }

    if (status) {
      this.collapsedMode = status === 'true';
    }
  }

  setSentimentsId(id: string): void {
    this.sentimentsId = id;
    window.sessionStorage.setItem(this.SentimentsIdName, id);
  }

  getSentimentsId(): string {
    return this.sentimentsId;
  }

  setCollapsedMode(status: boolean): void {
    this.collapsedMode = status;
    window.sessionStorage.setItem(this.CollapsedModeName, status.toString());
  }

  getCollapsedMode(): boolean {
    return this.collapsedMode;
  }
}
